<div class="comments-container">
  <div class="item" *ngFor="let commentItem of commentItems; let i = index; trackBy: trackByIndex">
    <app-comment-item [commentItem]="commentItem"></app-comment-item> 
  </div>
</div>
